import apiClient from './apiClient';

const taskClient = apiClient('tasks');

const defaultTaskApi = {
    async getActive() {
        const res = await taskClient.get('/defaults');
        return res.data;
    },

    async getAll() {
        const res = await taskClient.get('/defaults/all');
        return res.data;
    },

    async create(data) {
        const res = await taskClient.post('/defaults/create', data);
        return res.data;
    },

    async update(id, data) {
        const res = await taskClient.put(`/defaults/${id}`, data);
        return res.data;
    },

    async remove(id) {
        const res = await taskClient.delete(`/defaults/${id}`);
        return res.data;
    },
};

export default defaultTaskApi;
